import { render, staticRenderFns } from "./ShoppingListVisibilityWrapper.vue?vue&type=template&id=635732b3&"
import script from "./ShoppingListVisibilityWrapper.vue?vue&type=script&lang=js&"
export * from "./ShoppingListVisibilityWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports